module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAlCAYAAAAwYKuzAAAAzUlEQVRYhe3YMQrCQBBG4WcIFqKVV7DwWN7AWrDcA2iV1luZS1ipASUQmeCiQlKNxV/Mq1J+JEt2mEnXdTtgD8zQqgGSAe+CuFxTAKWGZbDSgJUgLFfZJ7bnJbCQIH26ApcMlK2Q1gXwDwXQWwC9BdCbPNAmmRWwAeYCnu9uwMnu4jOw1nH9VBtQelqwM1gLOMbq36D8GRSwjBf/QW8B9BZAbwH0FkBvebMlu5sx4AHYCoCGOtqw8ACmera+p53BVgAyVmvA9N4Hq9UA6QVZGDYUZupjJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/list.png
// module id = /gKx
// module chunks = 1